import React from 'react';
import './hero.css';
import { useNavigate } from 'react-router-dom';
import { hideNavbar } from '../header/header';
import { addStrongers } from '../../../utils/formatText';


export function Hero (props) {
  
  const nav = useNavigate();

  return (
    <section className="hero">
      <div className="container">
        <div className="content">
          <div className="left">
            <div className="text">
              <p>{props.texts.title}</p>

              <h1>
                {addStrongers(props.texts.description.zzpart1)}

                <br/>

                {addStrongers(props.texts.description.zzpart2)}
              </h1>
            </div>

            <img className="phone-img"
              src="/images/hero-full-puzzle.svg"
              alt={props.texts.image.alt}
              width="512"
              height="392"
            />

            <button onClick={() => {
                nav("/skills");hideNavbar();
              }}
            >
              {props.texts.button}
            </button>
          </div>

          <div className="right">
              <img className="pc-img" 
                src="/images/hero-full-puzzle.svg"
                alt={props.texts.image.alt}
                width="717"
                height="549"
              />
          </div>
        </div>
      </div>
    </section>
  );
}


export default Hero;